import { render, staticRenderFns } from "./ProfessionalCourierTariffModal.vue?vue&type=template&id=6c5dff2f&scoped=true"
import script from "./ProfessionalCourierTariffModal.vue?vue&type=script&lang=js"
export * from "./ProfessionalCourierTariffModal.vue?vue&type=script&lang=js"
import style0 from "./ProfessionalCourierTariffModal.vue?vue&type=style&index=0&id=6c5dff2f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c5dff2f",
  null
  
)

export default component.exports